<template>
	<div class="field">
		<label class="label">{{ label }}</label>
		<div class="control">
			<multiselect
				:name="name"
				track-by="id"
				label="name"
				:options="organisations"
				:value="myValue"
				:searchable="true"
				:loading="isFetching"
				deselect-label="Press enter to clear"
				@input="myBlur"
			/>
		</div>
		<p v-if="showError" class="help is-danger">{{ error }}</p>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import fieldMixin from "@lab/utils/fieldMixin";
import { sortBy } from "lodash";

export default {
	components: { Multiselect },
	mixins: [fieldMixin],
	props: {
		label: {
			type: String,
			default: () => "Organisation"
		}
	},
	computed: {
		myValue() {
			return this.organisations.find((o) => o.id === this.value);
		},
		organisations() {
			return sortBy(this.$store.getters.organisationsList, ["name"]);
		},
		isFetching() {
			return this.$store.getters.organisationsIsFetching;
		}
	},
	created() {
		this.fetchOrganisations();
	},
	methods: {
		fetchOrganisations() {
			this.$store.dispatch("organisationsLoad");
		},
		myBlur(org) {
			const val = org ? org.id : null;
			this.blur(val);
		}
	}
};
</script>

<style lang="scss">
// Removed scope so the margin changes would apply
@import "~vue-multiselect/dist/vue-multiselect.min.css";
.multiselect__content {
	margin-left: 0 !important;
	margin-top: 0 !important;
}
</style>
